// @ts-nocheck
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NgTryForDirective } from '../../../../directives/_old_directives/ng-try-for.directive';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { SelectComponent } from '../select/select.component';
import { TextareaComponent } from '../textarea/textarea.component';

@Component({
  selector: 'lbca-task-list-item',
  templateUrl: './task-list-item.component.html',
  styleUrl: './task-list-item.component.scss',
  imports: [
    SelectComponent,
    NgTryForDirective,
    NgTemplateOutlet,
    NgClass,
    TextareaComponent,
    DatePickerComponent,
    IconComponent,
  ],
})
export class TaskListItemComponent implements OnInit {
  @Input() template: any;
  @Input() set value(data) {
    this.data = data;
  }
  @Input('subFormModuleInstance') set subFormModuleInstanceController(fn) {
    this.subFormModuleInstance = fn;
  }
  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
    this.emmiterFeedback = dynamicFormService.feedbackEmitter;
  }
  @Input('disabled') set disabledSetter(status: boolean) {
    this.disabledControl = status;
  }
  @Input('taskOptions') set taskOptionsArray(data) {
    this.taskOptions = data;
    this.selectedTask = this.taskOptions.find((task) => task.id === this.data.taskAction_Phalange);
  }
  @Input('fieldOptions') set fieldOptionsObject(data) {
    this.fieldOptions = data;
  }
  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('error') errorEmmiter = new EventEmitter();
  @Output() validateCallback = new EventEmitter();
  data: any;
  subFormModuleInstance: any = null;
  dynamicFormService!: DynamicFormService;
  emmiterFeedback!: any;
  disabledControl = false;
  taskOptions: any[] = [];
  fieldOptions: any = {};
  selectedTask: any = {};
  subject = new Subject<any>();
  max: number | null = null;
  hasError = false;
  errors: any = {};

  ngOnInit() {
    this.subject.pipe(debounceTime(1500)).subscribe((value) => {
      this.changeEmmiter.emit(this.data);
    });
    this.validateCallback.emit(this.validate);
  }

  handleSelect() {
    if (this.disabledControl) {
      return;
    }
    this.data.selected = !this.data.selected;
    this.subject.next(this.data.selected);
  }

  handleTitle(event) {
    if (!event) {
      this.errors['taskAction_Phalange'] = ['Campo obrigatório'];
    } else {
      this.errors['taskAction_Phalange'] = [];
    }
    this.validate();
    this.data.taskAction_Phalange = event;
    this.selectedTask = this.taskOptions.find((item) => item.id === event);
    this.data.fields.dateDue = this.selectedTask.dateDue;
    this.data.fields.dateDueFatal = this.selectedTask.dateDueFatal;
    this.data.taskType = this.selectedTask.taskType ?? 'falange_tecnica';
    this.subject.next(event);
  }

  handleChange(event, field) {
    if (!event) {
      this.errors[field] = ['Campo obrigatório'];
    } else {
      this.errors[field] = [];
    }
    // this.validate();
    this.data['fields'][field] = event;
    this.subject.next(event);
  }

  validate = () => {
    let hasError = false;
    if (this.data.selected) {
      this.template?.fields.forEach((field) => {
        this.errors[field.entityKey] = this.data.fields[field.entityKey]
          ? []
          : ['Campo obrigatório'];
      });
      this.errors['taskAction_Phalange'] = this.data.taskAction_Phalange
        ? []
        : ['Campo obrigatório'];
      Object.keys(this.errors).forEach((error) => {
        if (this.errors[error].length > 0) {
          hasError = true;
        }
      });
    }
    this.errorEmmiter.emit(hasError);
    return (this.hasError = hasError);
  };

  handleError(event) {}
}
